// copy of https://github.com/volkswagen-onehub/mofa/blob/9947b093b0af5c991d74c1d0b7a38617eb528231/packages/components/src/responsive-image.tsx
import React, {useContext} from 'react';
import {useComponent} from '../component-library';
import {ThemeContext} from 'styled-components';
import {ImageSize} from '@volkswagen-onehub/whitelabel-e-mobility-data-types';

export interface BreakpointSizes {
  readonly [breakpoint: number]: string;
}

export interface ResponsiveImageProps {
  readonly src: string;
  readonly srcVariants?: ImageSize[];
  readonly breakpointSizes: BreakpointSizes;
  readonly alt: string;
  readonly testId?: string;
}

function createSrcSet(sizeSrcs: ImageSize[]): string {
  return sizeSrcs.map(({widthPx, url}) => `${url} ${widthPx}w`).join(', ');
}

function createSizes(
  breakpointSizes: BreakpointSizes,
  Breakpoints: Record<string, number>
): string {
  return Object.entries(breakpointSizes)
    .sort(
      ([breakpointA], [breakpointB]) =>
        parseInt(breakpointB, 10) - parseInt(breakpointA, 10)
    )
    .map(([breakpoint, size]) =>
      breakpoint === String(Breakpoints.default)
        ? `${size}`
        : `(min-width: ${breakpoint}px) ${size}`
    )
    .join(', ');
}

export const ResponsiveImage = React.memo(
  ({src, srcVariants, breakpointSizes, alt, testId}: ResponsiveImageProps) => {
    const {Breakpoints} = useContext(ThemeContext).internal;
    const srcSet = srcVariants ? createSrcSet(srcVariants) : undefined;
    const sizes = createSizes(breakpointSizes, Breakpoints);
    const Image = useComponent('Image');

    return (
      <Image
        alt={alt}
        src={src}
        srcSet={srcSet}
        sizes={sizes}
        testId={testId}
      />
    );
  }
);

ResponsiveImage.displayName = 'ResponsiveImage';
